import { ProductConfigurationPricingView } from '../views/product-configuration-pricing.view'

export const setupProductConfigurationPage = (): void => {
  const rootClass = '.conf-product'
  const root = document.querySelector<HTMLElement>(rootClass)

  if (!root) {
    return
  }

  new ProductConfigurationPricingView(root)
}
